<template>
  <div class="report-page">
    <template v-if="this.$route.query.label && this.$route.query.id && this.$route.query.property">
      <div v-if="currentUser">
        <div class="page-header">
          <div>
            <h1>Zgłoś {{ label }}</h1>
            <p>Opisz powód zgłoszenia. Twoje zgłoszenie zostanie przekazane do weryfikacji.</p>
          </div>
        </div>

        <section class="section-card">
          <div class="section-card-header">
            <h2>Formularz zgłoszenia</h2>
            <p class="section-subtitle">
              Dodaj komentarz, który pomoże nam szybciej zweryfikować zgłaszany element.
            </p>
          </div>

          <form class="report-form" @submit.prevent="confirmReport = true">
            <div class="form-group">
              <label for="comment">Komentarz <span>*</span></label>
              <textarea
                  required
                  name="comment"
                  v-model="comment"
                  id="comment"
                  placeholder="Opisz powód zgłoszenia..."
              ></textarea>
            </div>

            <div class="form-actions">
              <button type="submit" class="btn-primary">Wyślij zgłoszenie</button>
            </div>
          </form>

          <div class="confirm-card" v-if="confirmReport">
            <h3>Czy na pewno wysłać zgłoszenie?</h3>
            <p>Po potwierdzeniu zgłoszenie zostanie przekazane do administracji.</p>

            <div class="confirm-actions">
              <button class="btn-danger" @click="report">Tak, wyślij</button>
              <button class="btn-outline" @click="confirmReport = false">Nie</button>
            </div>
          </div>
        </section>
      </div>

      <div v-else class="state-card">
        <h1>Zaloguj się, aby zgłosić {{ label }}</h1>
        <p>Aby wysłać zgłoszenie, musisz być zalogowany/a na swoje konto.</p>

        <div class="state-actions">
          <button class="btn-primary" @click="$router.push('/login')">Zaloguj się</button>
          <button class="btn-outline" @click="$router.push('/register')">Zarejestruj się</button>
        </div>
      </div>
    </template>

    <div v-else class="state-card">
      <h1>Błąd, brak parametrów</h1>
      <p>Nie możemy wyświetlić formularza zgłoszenia, ponieważ brakuje wymaganych danych.</p>

      <div class="state-actions">
        <button class="btn-primary" @click="$router.push('/')">Wróć na stronę główną</button>
      </div>
    </div>
  </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';

export default {
  name: 'ReportPage',
  setup() {
    useMeta({ title: 'Zgłoś' });

    return {
      authStore: useAuthStore(),
      appStore: useAppStore()
    };
  },
  data() {
    return {
      label: null,
      id: null,
      property: null,
      comment: null,
      confirmReport: false
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  mounted() {
    this.getQuery();
  },
  methods: {
    getQuery() {
      this.label = this.$route.query.label;
      this.id = this.$route.query.id;
      this.property = this.$route.query.property;
    },
    report() {
      axios.post(`/Report`, {
        [this.property]: this.id,
        comment: this.comment
      }, authHeader()).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie wysłano zgłoszenie');
          this.$router.push('/');
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.report-page {
  max-width: 1000px;
  margin: 0 auto;
  padding: 32px 16px;
  box-sizing: border-box;
  color: #1f2937;
}

.page-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  margin: 0;
  font-size: 2.8rem;
  color: #1f2937;
  font-weight: 700;
}

.page-header p {
  margin: 6px 0 0;
  max-width: 760px;
  color: #6b7280;
  font-size: 1.4rem;
  line-height: 1.5;
}

.section-card,
.state-card {
  background-color: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
}

.section-card-header {
  margin-bottom: 16px;
}

.section-card-header h2,
.state-card h1 {
  margin: 0;
  font-size: 2rem;
  color: #1f2937;
  font-weight: 700;
}

.section-subtitle,
.state-card p {
  margin: 8px 0 0;
  max-width: 760px;
  color: #6b7280;
  font-size: 1.4rem;
  line-height: 1.5;
}

.report-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-size: 1.4rem;
  color: #374151;
  font-weight: 600;
}

.form-group label span {
  color: #dc3545;
}

.form-group textarea {
  border-radius: 8px;
  border: 1px solid #d1d5db;
  width: 100%;
  min-height: 180px;
  padding: 10px 12px;
  box-sizing: border-box;
  font-size: 1.4rem;
  outline: none;
  resize: vertical;
  transition: border-color 0.2s;
}

.form-group textarea:focus {
  border-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.12);
}

.form-actions {
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
}

.confirm-card {
  margin-top: 16px;
  background: #fff7ed;
  border: 1px solid #fed7aa;
  border-radius: 12px;
  padding: 14px;
}

.confirm-card h3 {
  margin: 0;
  color: #9a3412;
  font-size: 1.7rem;
}

.confirm-card p {
  margin: 6px 0 0;
  color: #7c2d12;
  font-size: 1.35rem;
  line-height: 1.5;
}

.confirm-actions,
.state-actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 12px;
}

.state-card {
  text-align: left;
}

.btn-primary,
.btn-outline,
.btn-danger {
  border-radius: 8px;
  font-size: 1.35rem;
  cursor: pointer;
  padding: 10px 14px;
}

.btn-primary {
  background: #f97316;
  color: #ffffff;
  border: none;
  font-weight: 600;
}

.btn-primary:hover {
  background: #ea6c0a;
}

.btn-outline {
  background: #ffffff;
  color: #1f2937;
  border: 1px solid #d1d5db;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

.btn-danger {
  background: #dc3545;
  color: #ffffff;
  border: none;
}

.btn-danger:hover {
  background: #b91c1c;
}

@media (max-width: 480px) {
  .report-page {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card,
  .state-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card-header h2,
  .state-card h1 {
    font-size: 1.8rem;
  }

  .form-actions,
  .confirm-actions,
  .state-actions {
    flex-direction: column;
  }

  .btn-primary,
  .btn-outline,
  .btn-danger {
    width: 100%;
    text-align: center;
  }
}
</style>